import React from 'react'
import './Loader.scss'

function Loader() {
    return (
        <div className="lds-spinner" data-testid="loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    )
}

export default Loader
